import { request } from '../request'

// 样本服务表新增或修改
export function querySampleServiceByUser(surveyId) {
  return request({
    url: `/wjsample/wjSampleService/querySampleServiceByUser?surveyId=${surveyId}`,
    method: 'GET'
  })
}
